import { withInstall } from '@zoryn/utils'
import Switch from './src/switch.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZSwitch: SFCWithInstall<typeof Switch> = withInstall(Switch)
export default ZSwitch

export * from './src/switch'
